import { useApiGet } from "../../utils/api";

const formatDate = (isoString: string): string => {
  const date = new Date(isoString);
  return date.toLocaleDateString([], {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
};

const formatTime = (isoString: string): string => {
  return new Date(isoString).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });
};

const typeLabel = (type: string): string => {
  return type === "feeding" ? "Feeding" : "Diaper Change";
};

const typeIcon = (type: string): string => {
  return type === "feeding" ? "🍼" : "💩";
};

interface LogEntry {
  id: number;
  type: string;
  ended_at: string;
}

export const Logs = () => {
  const { data, unavailable } = useApiGet("/api/user/logs");

  if (unavailable) return unavailable;

  const logs: LogEntry[] = data?.logs || [];

  // Group logs by date
  const groupedLogs = logs.reduce(
    (groups: Record<string, LogEntry[]>, log) => {
      const date = formatDate(log.ended_at);
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(log);
      return groups;
    },
    {},
  );

  return (
    <div className="container py-4">
      <h2 className="mb-4">Activity Logs</h2>

      {logs.length === 0 ? (
        <div className="card border-0 shadow-sm">
          <div className="card-body text-center py-5 text-muted">
            No activities logged yet
          </div>
        </div>
      ) : (
        Object.entries(groupedLogs).map(([date, entries]) => (
          <div key={date} className="mb-4">
            <h6 className="text-muted text-uppercase mb-3">{date}</h6>
            <div className="card border-0 shadow-sm">
              <ul className="list-group list-group-flush">
                {entries.map((log) => (
                  <li
                    key={`${log.type}-${log.id}`}
                    className="list-group-item d-flex justify-content-between align-items-center py-3"
                  >
                    <div className="d-flex align-items-center gap-3">
                      <span style={{ fontSize: "1.5rem" }}>
                        {typeIcon(log.type)}
                      </span>
                      <span>{typeLabel(log.type)}</span>
                    </div>
                    <span className="text-muted">{formatTime(log.ended_at)}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))
      )}
    </div>
  );
};
